export default __webpack_public_path__ + "static/media/contact-banner.701a98df.jpg";